module.exports = __webpack_public_path__ + "img/appstore-tra-grey.1fa8fce8.png";